var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconFbo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "navigationretailmobile",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(-235.000000, -16.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(236.000000, 17.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval-2",
    stroke: "#000000",
    strokeWidth: 1.5,
    cx: 9,
    cy: 9,
    r: 9
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.4618368,11.1915766 C11.7747319,10.7027957 10.7208974,10.9624333 10.0641539,10.0919636 C10.0641539,10.0919636 9.81977083,9.81705663 10.36957,9.14508813 C10.9193838,8.4730901 10.9651475,7.40400098 10.8277088,6.57930969 C10.6903735,5.75460363 9.91146063,5.20481928 9.10202389,5.20481928 C8.29258716,5.20481928 7.51365954,5.75460363 7.37633897,6.57930969 C7.2388855,7.40400098 7.28464918,8.4730901 7.83446306,9.14508813 C8.38424742,9.81705663 8.13987913,10.0919636 8.13987913,10.0919636 C7.48313565,10.9624333 6.42946353,10.7027957 5.74221094,11.1915766 C5.05497312,11.6801803 5.22292094,12.7951807 5.22292094,12.7951807 L12.9811268,12.7951807 C12.9811268,12.7951807 13.1490747,11.6801803 12.4618368,11.1915766",
    id: "Fill-3",
    fill: "#000000"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFbo);
export default __webpack_public_path__ + "static/media/icon-fbo.775961a3.svg";
export { ForwardRef as ReactComponent };